export default __webpack_public_path__ + "static/media/question.f80f0db7.svg";